import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import { LogoIcon, LogoIconVariant } from '@repo/ui/Icon';
import styled, { useTheme } from 'styled-components';

import { PATH } from 'routers/paths';

import LoginForm from './components/LoginForm';

export default function SignInWithPasswordPage() {
  const theme = useTheme();
  return (
    <SPageWrapper>
      <SPageContainer>
        {/* Logo */}
        <SLogoContainer>
          <Link to={PATH.DASHBOARD} rel="nosublink">
            <LogoIcon
              width={200}
              height={38}
              style={{ display: 'inline-block' }}
              color={theme.color.text.default}
              variant={LogoIconVariant.CHAT}
            />
          </Link>
        </SLogoContainer>
        {/* GuideText */}
        <SGuideTextContainer>
          <Trans i18nKey="login.userinfo_message" />
        </SGuideTextContainer>
        {/* Login */}
        <SLoginFormContainer>
          <LoginForm />
        </SLoginFormContainer>
        {/* Password Reset */}
        {/* <SPasswordResetContainer>
          <Link to={PATH.AUTH.PASSWORD_FORGOT} rel="nosublink">
            {t('login.userinfo_forgot_password_message')}
          </Link>
        </SPasswordResetContainer> */}
      </SPageContainer>
    </SPageWrapper>
  );
}

const SPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  height: calc(100vh - 72px - 120px);
  justify-content: center;
  min-height: 100dvh;

  color: ${({ theme }) => theme.color.text.default};
  background: ${({ theme }) => theme.color.static.white};

  @media ${({ theme }) => theme.device.medium} {
    align-items: center;
  }
`;

const SPageContainer = styled.div`
  margin: 4px auto 0;
  width: 400px;

  input {
    padding-right: 0px;
  }

  .logo {
    margin-bottom: 52px;
  }
  & .passwordInput .reset-btn {
    position: absolute;
    right: 50px;
  }

  @media ${({ theme }) => theme.device.medium} {
    margin: unset;
    margin-top: 4px;
    width: 100%;
    max-width: 400px;
  }
`;

const SLogoContainer = styled.div`
  text-align: center;
  height: 110px;
`;

const SGuideTextContainer = styled.div`
  margin-bottom: 22px;
  font-size: 16px;
  line-height: 1.4;
  text-align: center;

  strong {
    font-weight: 600;
  }
`;

const SLoginFormContainer = styled.div``;

const SPasswordResetContainer = styled.div`
  margin-top: 20px;
  color: ${({ theme }) => theme.palette.neutral[30]};
  font-size: 14px;
  text-align: center;
  text-decoration: underline;
`;
